/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SqdCommonModule } from '../common/sqd-common.module';
import { MiddlewareBrowseComponent } from './middleware-browse.component';
import { MiddlewareConnectorSelectorComponent } from './middleware-connector-selector.component';
import { MiddlewareReentryComponent } from './middleware-reentry.component';
import { MiddlewareBrowseModalComponent } from './middleware-browse-modal.component';

@NgModule({
  declarations: [
    MiddlewareBrowseComponent,
    MiddlewareBrowseModalComponent,
    MiddlewareConnectorSelectorComponent,
    MiddlewareReentryComponent,
  ],
  imports: [CommonModule, SqdCommonModule],
})
export class MiddlewareModule {}
